import * as Yup from 'yup';

export const zygosityValidationSchema = Yup.object({
  zygosity: Yup.string().required('Zygosity is required'),
});
